import { Pipe, PipeTransform } from '@angular/core';
import { HashMap, TranslocoScope, TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../ui-tools-transloco-scope';
import { CommonWording } from './common-wording';

@Pipe({
  name: 'commonWording'
})
export class CommonWordingPipe<T = CommonWording> implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: T, params: HashMap = {}, lang: string | TranslocoScope = UI_TOOLS_TRANSLOCO_SCOPE, keyPrefix: string = ''): Observable<string> {
    return this.translocoService.selectTranslate(keyPrefix + 'commonWording.' + value, params, lang);
  }
}
